import React, { useState, useEffect } from 'react'
import Tooltip from '../common/tooltip.js';
import { Link } from "react-router-dom";
import { ArrowLongLeftIcon } from '@heroicons/react/24/solid';
import axios from "axios";
import { PencilIcon, NoSymbolIcon, CheckCircleIcon, ArrowTopRightOnSquareIcon, ClipboardDocumentListIcon, GiftIcon } from '@heroicons/react/24/outline';
import $ from 'jquery';
import { useAlert } from "react-alert";
import earning from "./../../assets/images/earning.png";

const ManageRewards = () => {

    const [isRedeemOpen, setIsRedeemOpen] = useState(true);
    const [redeemCount, setRedeemCount] = useState(0);
    const [earnCount, setEarnCount] = useState(0);
    const [openRequests, setOpenRequests] = useState(0);
    const [isEarnOpen, setIsEarnOpen] = useState(false);
    const [redeemPats, setRedeemPats] = useState([]);
    const [earnPats, setEarnPats] = useState([]);
    const alert = useAlert();

    useEffect(() => {
        axios({
            url: process.env.REACT_APP_API_URL + "api/rewards/allRewards",
            method: "GET",
        })
            .then((res) => {
                if (res.data.issuccessful) {
                    setRedeemPats(res.data.redeem);
                    setEarnPats(res.data.earn);
                }
            })

            .catch((err) => {
                console.error('There was an error!', err);
            });

        axios({
            url: process.env.REACT_APP_API_URL + "api/rewards/rewardsSummary",
            method: "GET",
        })
            .then((res) => {
                if (res.data.issuccessful) {
                    setRedeemCount(res.data.redeem);
                    setEarnCount(res.data.earn);
                    setOpenRequests(res.data.requests);
                }
            })

            // Catch errors if any
            .catch((err) => {
                console.error('There was an error!', err);
            });

    }, [])



    $(document).ready(function () {
        setTimeout(function () {
            $('#myTable').DataTable();
        }, 1000);
    })

    const disableReward = (id) => {
        // console.log("disable", id);
        axios.post(process.env.REACT_APP_API_URL + "api/rewards/disableReward", {
            id,
        })
            .then(function (response) {
                if (response.data.issuccessful) {
                    alert.success(response.data.message)
                    setTimeout(() => {
                        window.location.reload(false)
                    }, 1500)
                } else {
                    alert.error(response.data.message)
                }
            })
            .catch(function (error) {
                alert.error(error);
            });
    }

    const enableReward = (id) => {
        // console.log("enable", id);
        axios.post(process.env.REACT_APP_API_URL + "api/rewards/enableReward", {
            id,
        })
            .then(function (response) {
                if (response.data.issuccessful) {
                    alert.success(response.data.message)
                    setTimeout(() => {
                        window.location.reload(false)
                    }, 1500)
                } else {
                    alert.error(response.data.message)
                }
            })
            .catch(function (error) {
                alert.error(error);
            });
    }

    const handlechange = (string) => {
        if (string == 'redeem') {
            setIsRedeemOpen(true);
            setIsEarnOpen(false);
        } else if (string == 'earn') {
            setIsEarnOpen(true);
            setIsRedeemOpen(false);
        }
    }
    return (
        <div style={{ position: "relative" }} className="rewardRequest">
            <div style={{ display: "flex", justifyContent: "space-between" }} className='admin-header'>
                <Link to="/admin" style={{ display: "flex", gap: '10px', color: 'black' }}>
                    <ArrowLongLeftIcon className="" style={{ width: '30px' }} />
                    <p style={{ marginBottom: '0' }} >Manage Rewards</p>
                </Link>
                <Link to="/admin/manage-rewards/add-new-reward" style={{ backgroundColor: "#008bff", color: '#fff', borderRadius: "30px", padding: '5px 20px' }}>Add Rewards</Link>
            </div>

            <div style={{ marginTop: "40px", backgroundColor: "white", padding: "20px", borderRadius: "8px", display: 'flex', gap: '15px', justifyContent: "space-between" }}>
                <Link to="/admin/manage-rewards/open-requests" className="rewards-count">
                    <ClipboardDocumentListIcon style={{ width: "2rem", height: "2rem" }} />
                    <div>
                        <p style={{ margin: "2px 0 10px", font: "normal normal bold 1.5rem/25px Poppins" }}>{openRequests.count}</p>
                        <p style={{ margin: "0", fontFamily: "Poppins" }}>Open Requests <ArrowTopRightOnSquareIcon style={{ width: "1rem", height: "1rem" }} /></p>
                    </div>
                </Link>
                <div className={`rewards-count ${isRedeemOpen ? "selected" : ""}`} onClick={() => handlechange('redeem')}>
                    <GiftIcon style={{ width: "2rem", height: "2rem" }} />
                    <div>
                        <p style={{ margin: "2px 0 10px", font: "normal normal bold 1.5rem/25px Poppins" }}>{redeemCount.count}</p>
                        <p style={{ margin: "0", fontFamily: "Poppins" }}>Gift Cards</p>
                    </div>
                </div>
                <div className={`rewards-count ${isEarnOpen ? "selected" : ""}`} onClick={() => handlechange('earn')}>
                    <img src={earning} style={{ width: "2rem", height: "2rem" }} alt='Earn Pats' />
                    <div>
                        <p style={{ margin: "2px 0 10px", font: "normal normal bold 1.5rem/25px Poppins" }}>{earnCount.count}</p>
                        <p style={{ margin: "0", fontFamily: "Poppins" }}>Earn Pats</p>
                    </div>
                </div>
            </div>

            {/* <div style={{ marginTop: "40px", backgroundColor: "white", padding: "20px", borderRadius: "8px" }}> */}
            {isRedeemOpen && (
                <div style={{ marginTop: "40px", backgroundColor: "white", padding: "20px", borderRadius: "8px" }}>
                    <p style={{ marginBottom: '20px', fontSize: "18px", color: "black", fontWeight: "600", fontFamily: "Poppins" }}>Redeem Pats</p>
                    <table id="myTable" className="display table table-hover" data-page-length='10'>
                        <thead>
                            <tr>
                                <th>Brand</th>
                                <th>Amount</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {redeemPats.map((reward, index) => {

                                return (
                                    <tr key={index} id={reward.UserID}>
                                        <td>
                                            <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                                <img
                                                    src={process.env.REACT_APP_REWIMG_URL + reward.RewardImage}
                                                    alt="Reward Image"
                                                    style={{ width: "70px" }}
                                                />
                                                {reward.RewardName}
                                            </div>

                                        </td>
                                        <td>{reward.RewardAmount}</td>
                                        <td className='d-flex' style={{ alignItems: 'center', color: "#000", justifyContent: "space-around", padding: "12px", height: "40px", gap: "10px" }}>
                                            <Tooltip text="Edit reward">
                                                <Link to={`/admin/manage-rewards/edit-reward/${btoa(reward.RewardID)}`} style={{ color: '#000', height: '18px' }}>

                                                    <PencilIcon style={{ width: '18px' }} data-id={reward.RewardID} />

                                                </Link>
                                            </Tooltip>
                                            {reward.IsActive == 1 ? (
                                                <Tooltip text="Disable reward">
                                                    <NoSymbolIcon style={{ width: '18px' }} className='delete-btn' onClick={() => disableReward(reward.RewardID)} />
                                                </Tooltip>
                                            ) : (
                                                <Tooltip text="Enable reward">
                                                    <CheckCircleIcon style={{ width: '18px', cursor: 'pointer' }} className='enable-btn' onClick={() => enableReward(reward.RewardID)} />
                                                </Tooltip>
                                            )}

                                        </td>
                                        {/* <td><button id={`delete-${user.UserID}`} className='issue-btn' data-id={user.UserID}>Delete</button></td> */}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            )}


            {isEarnOpen && (
                <div style={{ marginTop: "40px", backgroundColor: "white", padding: "20px", borderRadius: "8px" }}>
                    <p style={{ marginBottom: '20px', fontSize: "18px", color: "black", fontWeight: "600", fontFamily: "Poppins" }}>Redeem Pats</p>
                    <table id="myTable" className="display table table-hover" data-page-length='10'>
                        <thead>
                            <tr>
                                <th>Brand</th>
                                <th>Amount</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {earnPats.map((reward, index) => {

                                return (
                                    <tr key={index} id={reward.UserID}>
                                        <td>
                                            <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                                <img
                                                    src={process.env.REACT_APP_REWIMG_URL + reward.RewardImage}
                                                    alt="Reward Image"
                                                    style={{ width: "70px" }}
                                                />
                                                {reward.RewardName}
                                            </div>

                                        </td>
                                        <td>{reward.RewardAmount}</td>
                                        <td className='d-flex' style={{ alignItems: 'center', color: "#000", justifyContent: "space-around", padding: "12px", height: "40px", gap: "10px" }}>
                                            <Tooltip text="Edit reward">
                                                <Link to={`/admin/manage-rewards/edit-reward/${btoa(reward.RewardID)}`} style={{ color: '#000', height: '18px' }}><PencilIcon style={{ width: '18px' }} data-id={reward.RewardID} /></Link>
                                            </Tooltip>
                                            {reward.IsActive == 1 ? (
                                                <Tooltip text="Disable reward">
                                                    <NoSymbolIcon style={{ width: '18px' }} className='delete-btn' onClick={() => disableReward(reward.RewardID)} />
                                                </Tooltip>
                                            ) : (
                                                <Tooltip text="Enable reward">
                                                    <CheckCircleIcon style={{ width: '18px', cursor: 'pointer' }} className='enable-btn' onClick={() => enableReward(reward.RewardID)} />
                                                </Tooltip>
                                            )}

                                        </td>
                                        {/* <td><button id={`delete-${user.UserID}`} className='issue-btn' data-id={user.UserID}>Delete</button></td> */}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            )}


            {/* </div> */}
        </div>
    )
}

export default ManageRewards